import React from 'react';
import Event from './EventItem.jsx';
import './EventDisplay.css'

export default class EventsList extends React.PureComponent {
  render() {
    const {eventsAtTime, singleTeamView, time} = this.props;
    if (eventsAtTime === undefined) {
      return (<div className="loading-gif" />);
    };
    return (
      <div className="eventTimeBlock ">
        {eventsAtTime.map((event, idx) => <Event key={`event-${time}-${idx}`} time={time} singleTeamView={singleTeamView} event={event} />)}
      </div>
    );
  }
}
